import React from 'react';

import FloatingElements from './FloatingElements';

const BACKGROUND_IMAGE_URL =
  'https://haatnexusprodinfosys.blob.core.windows.net/images/_V6A0037.f1b6c75e3f084665ed0c.jpg';

/**
 * Decorative left panel for the login page. Keeps the background image and
 * gradient only — copy was removed so the form column carries the messaging.
 */
const LoginLeftPanel: React.FC = () => (
  <div
    className="hidden lg:flex lg:w-1/2 relative overflow-hidden text-white"
    aria-hidden="true"
  >
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${BACKGROUND_IMAGE_URL})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/75 to-haat-red-600/30" />
    <FloatingElements />
  </div>
);

export default LoginLeftPanel;
